/* eslint-disable import/no-named-as-default */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Routes, Route,
} from 'react-router-dom'
import Page from 'src/components/Page'
import { Alert, AlertTitle } from '@material-ui/lab'
import CourseResultPackages from './CourseResultPackages'
import CourseResultReport from './CourseResultReport'
import {
  selectorUserState, getUserState,
} from '../../app/slices/userSlice'
import {
  getUserPackages, selectorUserPackage,
} from '../../app/slices/packageSlice'

const CourseResult = () => {
  const dispatch = useDispatch()
  const packages = useSelector(selectorUserPackage)
  const userState = useSelector(selectorUserState)

  useEffect(() => {
    dispatch(getUserPackages())
    dispatch(getUserState())
  }, [])

  console.log('userInfo', packages?.[0].status)

  let msg = null
  if (userState === 1) {
    msg = 'شما هنوز پکیجی خریداری نکرده اید'
  } else if (userState === 3) {
    msg = 'شما هنوز در هیچ آزمونی شرکت نکرده اید'
  }

  return (
    <Page
      title="نتیجه آزمون"
    >
      {(userState === 4 || userState === 5) ? (
        <Routes>
          <Route path="/" element={<CourseResultPackages />} />
          <Route path="/report/:userExamId" element={<CourseResultReport />} />
        </Routes>
      )
        : (
          <Alert
            style={{
              padding: '0 !important',
              width: '100% !important',
              display: 'flex',
            }}
            severity="warning"
          >
            <AlertTitle style={{ padding: '0 !important' }}>توجه</AlertTitle>
            {msg}
          </Alert>
        )}
    </Page>
  )
}

export default CourseResult
